export function decodeJwtPayload<T>(token: string | null | undefined): T | null {
  const payload = token?.split('.')[1];
  if (!payload) {
    return null;
  }

  // JWTs use base64url without padding; atob expects standard base64 (forgiving about padding).
  const base64 = payload.replaceAll('-', '+').replaceAll('_', '/');
  const bytes = Uint8Array.from(atob(base64), (char) => char.codePointAt(0) ?? 0);
  return JSON.parse(new TextDecoder().decode(bytes)) as T;
}
